import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Select, Button, Card, message } from "antd";
import {
  UserOutlined,
  LockOutlined,
  ShopOutlined,
  GiftOutlined,
  NumberOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import Endpoints from "../../api/endpoints";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import routes from "../../utils/routes";
const CreateShop = () => {
  const [form] = Form.useForm();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [sectors, setSectors] = useState([]);
  const [isSectorLoading, setIsSectorLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onFinish = async (values) => {
    setIsSubmitting(true);
    const response = await EndpointFunctions.postData({
      endpointURL: Endpoints.createShop,
      axiosPrivate: axiosPrivate,
      requestBody: values,
    });
    setIsSubmitting(false);
    if (response.success) {
      message.success("Mağaza oluşturuldu");
      navigate(routes.shops);
    } else {
      message.error(response.errorMessage || "Mağaza oluşturulamadı");
    }
  };

  const fetchSectors = async () => {
    try {
      setIsSectorLoading(true);
      const response = await EndpointFunctions.fetchData({
        endpointURL: Endpoints.getAllSectors,
        axiosPrivate: axiosPrivate,
      });
      const sectorData = (response.data || []).map((sector) => ({
        value: sector.id,
        label: sector.description,
      }));
      setSectors(sectorData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsSectorLoading(false);
    }
  };

  useEffect(() => {
    fetchSectors();
  }, []);
  return (
    <div style={{ maxWidth: 600, margin: "40px auto", padding: "0 20px" }}>
      <Card title="Yeni Mağaza Oluştur" type="inner">
        <Form
          form={form}
          name="createShop"
          onFinish={onFinish}
          layout="vertical"
          requiredMark={true}>
          <Form.Item
            name="sectorId"
            label="Sektör"
            rules={[{ required: true, message: "Lütfen bir sektör seçin" }]}>
            <Select
              options={sectors}
              placeholder="Sektör seçin"
              loading={isSectorLoading}>
              {/* Add more sectors as needed */}
            </Select>
          </Form.Item>

          <Form.Item
            name="shopName"
            label="Mağaza Adı"
            rules={[{ required: true, message: "Lütfen mağaza adını girin" }]}>
            <Input prefix={<ShopOutlined />} placeholder="Mağaza adını girin" />
          </Form.Item>

          <Form.Item
            name="stampCountForPrize"
            label="Ödül için Gereken Damga Sayısı"
            rules={[
              {
                required: true,
                message: "Lütfen gereken damga sayısını girin",
              },
            ]}>
            <InputNumber
              prefix={<NumberOutlined />}
              placeholder="Damga sayısını girin"
              min={1}
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            name="prize"
            label="Ödül Açıklaması"
            rules={[
              { required: true, message: "Lütfen ödül açıklamasını girin" },
            ]}>
            <Input
              prefix={<GiftOutlined />}
              placeholder="Ödül açıklamasını girin"
            />
          </Form.Item>

          <Form.Item
            name="email"
            label="E-posta"
            rules={[
              { required: true, message: "Lütfen e-posta adresini girin" },
              {
                type: "email",
                message: "Lütfen geçerli bir e-posta adresi girin",
              },
            ]}>
            <Input
              prefix={<UserOutlined />}
              placeholder="E-posta adresini girin"
              autoComplete="new-email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Şifre"
            rules={[{ required: true, message: "Lütfen şifrenizi girin" }]}>
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Şifrenizi girin"
              autoComplete="new-password"
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Şifre Tekrar"
            dependencies={["password"]}
            rules={[
              { required: true, message: "Lütfen şifrenizi tekrar girin" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Şifreler eşleşmiyor"));
                },
              }),
            ]}>
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Şifrenizi tekrar girin"
              autoComplete="new-password"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={isSubmitting}>
              Mağaza Oluştur
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CreateShop;
